import { whatIfOptionsOrDefaultSelector, whatIfInnerSelector } from '../WhatIfsSelector';

export const availableCashflowSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).AvailableCashflow;

export const maxCashflowSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).MaxCashflow;

export const totalAllocatedCashflowOtherGoalsSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).TotalAllocatedCashflowOtherGoals;

export const isSaveRemainingCashflowHandlingModeSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).IsSaveRemainingCashflowHandlingMode;

export const allocatedCashflowSelector = (state, props) =>
  whatIfInnerSelector(state, props).AllocatedCashflow;
export const allocateExcessCashflowSelector = (state, props) =>
  whatIfInnerSelector(state, props).AllocateExcessCashflow;
